module.exports = __webpack_public_path__ + "img/MG_4720R-scaled.2db0a556.jpg";